enum Routes {
  HOME = "/",
  COMING_SOON = "/coming_soon",
  LOGIN = "/login",
  FORGOT_PASSWORD = "/forgot_password",
  RESET_PASSWORD = "/reset_password",
  USER_MY_ACCOUNT = "/user/my-account",
  USER_PROFILE = "/user/profile",
  FOOD = "/food",
  FOOD_INGREDIENT = "/food/ingredient/list",
  FOOD_INGREDIENT_EDIT = "/food/ingredient/edit",
  FOOD_INGREDIENT_CREATE = "/food/ingredient/create",
  FOOD_UPDATE_SUPPLIER_INFO_BY_INVOICE = "/food/supplier_info/update/invoice",
  FOOD_RECIPE = "/food/recipe/list",
  FOOD_GROUP = "/food/group/list",
  FOOD_TAG_BOARD = "/food/tag/board",
  FOOD_RECIPE_EDIT = "/food/recipe/edit",
  FOOD_RECIPE_CREATE = "/food/recipe/create",
  FOOD_RECIPE_VIEW = "/food/recipe/view",
  NUTRITION = "/recipe/nutrition",
  RECIPE_GRAPH = "/recipe/graph",
  MENU = "/menu/list",
  MENU_CALENDAR = "/menu/calendar",
  MENU_EDIT = "/menu/edit",
  MENU_CREATE = "/menu/create",
  MENU_LOOP = "/menu/loop/list",
  MENU_LOOP_EDIT = "/menu/loop/edit",
  MENU_LOOP_CREATE = "/menu/loop/create",
  ORDERING = "/ordering",
  INVENTORY = "/inventory/list",
  INVENTORY_EDIT_CSV = "/inventory/edit/csv",
  INVENTORY_DETAILS = "/inventory/details",
  INVENTORY_PURCHASING = "/inventory/purchasing",
  INVENTORY_PURCHASING_CYCLE = "/inventory/purchasing/cycle",
}

export default Routes;
